import React, { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function ConditionalPageH1() {
  const { pathname } = useLocation();
  const [shouldShowFallback, setShouldShowFallback] = useState(false);

  useLayoutEffect(() => {
    const root = document.getElementById("root");

    if (!root) {
      return undefined;
    }

    let frameId = null;

    const checkPageH1 = () => {
      if (frameId) {
        window.cancelAnimationFrame(frameId);
      }

      frameId = window.requestAnimationFrame(() => {
        const isArticlePage =
          /^\/blog\/[^/]+\/?$/.test(window.location.pathname);

        const pageHasItsOwnH1 = Boolean(
          root.querySelector(
            'h1:not([data-fallback-page-h1="true"])'
          )
        );

        setShouldShowFallback(
          !isArticlePage && !pageHasItsOwnH1
        );
      });
    };

    checkPageH1();

    const observer = new MutationObserver(checkPageH1);

    observer.observe(root, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();

      if (frameId) {
        window.cancelAnimationFrame(frameId);
      }
    };
  }, [pathname]);

  if (!shouldShowFallback) {
    return null;
  }

  return (
    <h1
      className="seo-hidden"
      data-fallback-page-h1="true"
    >
      פשוט למצוא בעל מקצוע
    </h1>
  );
}

export default ConditionalPageH1;